import { render, staticRenderFns } from "./KnowledgeContentFolderSelector.vue?vue&type=template&id=206d2984&scoped=true&"
import script from "./KnowledgeContentFolderSelector.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentFolderSelector.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeContentFolderSelector.vue?vue&type=style&index=0&id=206d2984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d2984",
  null
  
)

export default component.exports